import React, { useState, useEffect, Fragment } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link
} from "react-router-dom";
import Button from '@material-ui/core/Button';
import auth, { db } from './utils/firebase';
import HeaderBar from './components/HeaderBar';
import QuestionContext from './QuestionContext'
import SurveyContextProvider from './SurveyContext';
import './App.css'
import HomePage from './containers/Surveys/ActiveSurveys';
import ArchivedSurveys from './containers/Surveys/ArchivedSurveys';
import SurveyPage from './containers/Surveys/SurveyPage';
import CreateSurvey from './containers/Surveys/CreateSurvey';
import EditSurvey from './containers/Surveys/EditSurvey';
import AllCustomers from './containers/Customers/AllCustomers';
import CampaignSurveys from './containers/Customers/CampaignSurveys';
import AllQuestions from './containers/Questions/AllQuestions';
import MultiselectLabels from './containers/Questions/MultiselectLabels';
import AllQuestionSets from './containers/QuestionSets/AllQuestionSets';
import ArchivedQuestions from './containers/Archived/ArchivedQuestions';
import CustomerCampaigns from './containers/Campaigns/CustomerCampaigns';
import LoginPage from './containers/Login/LoginPage';

const RouterApp = () => {
  return (
    <Router>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </Router>
  )
}

const App = (props) => {
  const [loading, setLoading] = useState(true);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [questions, setQuestions] = useState([]);

  const InitAuth = () => {
    // listens for realtime user authentication updates
    auth.onAuthStateChanged(function (user) {
      setLoading(true);
      if (user) {
        // User is signed in.
        console.log("User is signed in");
        // if questions array is null or empty, set question listener
        if (!questions || !questions.length) {
          getQuestions();
        }
        setLoading(false)
      } else {
        // No user is signed in.
        console.log("No User")
        setLoading(false)
      }
    });
  }

  // on page load, set auth listener
  useEffect(InitAuth, [])

  if (props.location.pathname === '/' && auth.currentUser) {
    return <Redirect to={'surveys'} />
  }

  // pulls question data from database and listens for realtime updates
  const getQuestions = () => {
    db.collection("question_store").onSnapshot(querySnapshot => {
      const questions = querySnapshot.docs.map(doc => doc.data());
      const sorted_questions = questions.sort((a, b) => {
        let aDate = a.dateAdded.toDate();
        let bDate = b.dateAdded.toDate();
        if (aDate < bDate) return 1;
        if (bDate < aDate) return -1;
        return 0;
      })
      setQuestions(sorted_questions);
    });
  }

  function openNav() {
    document.getElementById("mySidebar").style.width = "250px";
    document.getElementById("main").style.marginLeft = "250px";
    setOpenSidebar(true);
  }

  function closeNav() {
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginLeft = "0";
    setOpenSidebar(false);
  }

  function goTo(url) {
    props.history.push(url);
    closeNav();
  }

  function signOutUser() {
    auth.signOut().then(() => {
      console.log("Sign out successful");
    }).catch(err => {
      console.log("Error signing out: ", err);
    });
  }

  return (
    <div>
      <Switch>
        {(!auth.currentUser && !loading) &&
          <Route path='/login'> <LoginPage /> </Route>
        }
        {loading === false &&
          <Fragment>
            <Sidebar closeNav={closeNav} goTo={goTo} signOutUser={signOutUser} />
            <div id="main" className="main">
              <HeaderBar openSidebar={openSidebar} openNav={openNav} closeNav={closeNav} />
              <div style={{ padding: 10 }}>
                <PrivateRoute user={auth.currentUser}>
                  <QuestionContext.Provider value={questions}>
                    <SurveyContextProvider>
                      <Switch>
                        <Route path='/surveys/create/:id' render={(props) => <CreateSurvey {...props} />} />
                        <Route path='/surveys/create'> <CreateSurvey {...props} /> </Route>
                        <Route path='/surveys/:id/edit' render={(props) => <EditSurvey {...props} />} />
                        <Route path='/surveys/:id' render={(props) => <SurveyPage {...props} />} />
                        <Route path='/surveys'> <HomePage {...props} /> </Route>
                        <Route path='/archivedsurveys'> <ArchivedSurveys {...props} /> </Route>
                        <Route exact path='/customers'> <AllCustomers {...props} /> </Route>
                        <Route path='/questions'> <AllQuestions {...props} /> </Route>
                        <Route path='/multiselectlabels'> <MultiselectLabels {...props} /> </Route>
                        <Route path='/questionsets'> <AllQuestionSets /> </Route>
                        <Route path='/archivedquestions' render={(props) => <ArchivedQuestions {...props} />} />
                        <Route exact path='/campaigns/:clientId/surveys/:campaignId' render={(props) => <CampaignSurveys {...props} />} />
                        <Route exact path='/campaigns/:id' render={(props) => <CustomerCampaigns {...props} />} />
                      </Switch>
                    </SurveyContextProvider>
                  </QuestionContext.Provider>
                </PrivateRoute>
              </div>
            </div>
          </Fragment>
        }
      </Switch>
    </div>
  );
}

function Sidebar(props) {
  return (
    <div className="sidebar" id="mySidebar">
      <Link to="/surveys">Active Surveys</Link>
      <Link to="/archivedsurveys">Archived Surveys</Link>
      <Link to="/customers">Customers</Link>
      <Link to="/questionsets">Question Sets</Link>
      <Link to="/questions">Questions</Link>
      <Link to="/archivedquestions">Archived Questions</Link>
      <Link to="/multiselectlabels">Multiselect Labels</Link>
      <hr />
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <a href="https://volume.elucd.com/" rel="noopener noreferrer" target="_blank"> Volume Tracker </a>
        <a href="https://reports.elucd.com/" rel="noopener noreferrer" target="_blank"> Report Generator </a>
        <a href="http://crosstabs.elucd.com/" rel="noopener noreferrer" target="_blank"> Crosstabs </a>
      </div>
      <Button onClick={props.signOutUser} variant="outlined" style={{ margin: 20, width: '80%' }}> Logout </Button>
    </div>
  )
}

function PrivateRoute({ children, user, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        (user && !user.isAnonymous) ? (
          children
        ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
      }

    />
  );
}

export default RouterApp;
